import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Send } from 'lucide-react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { klarysUrl } from './klarysApi';

export const KlarysPartageDialog = ({ texte, headers, onClose, type = 'demande', titre }) => {
  const [dest, setDest] = useState(null);
  const [sel, setSel] = useState(new Set());
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    axios.get(klarysUrl('/destinataires'), { headers }).then((r) => setDest(r.data.items)).catch(() => setDest([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const basculer = (id) => setSel((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const envoyer = async () => {
    setBusy(true);
    try {
      const r = await axios.post(klarysUrl('/partages'), { texte, message, destinataires: [...sel], type, ...(titre ? { titre } : {}) }, { headers });
      toast.success(`${type === 'modele' ? 'Modèle partagé' : 'Demande partagée'} avec ${r.data.envoyes} personne(s)`);
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || 'Partage impossible'); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="z-[70] max-w-md" onEscapeKeyDown={(e) => e.stopPropagation()} data-testid="klarys-partage-dialog">
        <DialogHeader><DialogTitle>{type === 'modele' ? 'Partager ce modèle' : 'Partager cette demande'}</DialogTitle></DialogHeader>
        <p className="rounded-lg bg-slate-50 p-2 text-xs text-slate-700" data-testid="klarys-partage-texte">{texte}</p>
        <p className="text-[11px] text-slate-500">Le destinataire la lancera avec ses propres droits ; toute modification lui sera soumise pour confirmation.</p>
        <div className="max-h-48 overflow-y-auto rounded-lg border border-slate-200">
          {dest === null ? <p className="p-3 text-xs text-slate-400">Chargement…</p> : !dest.length ? <p className="p-3 text-xs text-slate-500">Aucun autre administrateur.</p> : dest.map((u) => (
            <label key={u.id} className="flex cursor-pointer items-center gap-2 border-b border-slate-100 px-3 py-2 text-xs last:border-0 hover:bg-slate-50">
              <input type="checkbox" checked={sel.has(u.id)} onChange={() => basculer(u.id)} data-testid={`klarys-partage-dest-${u.email}`} />
              <span className="font-medium text-slate-800">{u.nom}</span>
              <span className="text-slate-500">{u.email}</span>
              <span className="ml-auto rounded bg-slate-100 px-1.5 py-0.5 text-[10px] text-slate-600">{u.role === 'super_admin' ? 'Super admin' : 'Admin'}</span>
            </label>
          ))}
        </div>
        <Textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={2} maxLength={300} placeholder="Message (facultatif)" className="text-sm" data-testid="klarys-partage-message" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="klarys-partage-annuler">Annuler</Button>
          <Button onClick={envoyer} disabled={busy || !sel.size} className="bg-[#0a3d62] hover:bg-[#0c4a77]" data-testid="klarys-partage-envoyer">
            {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Send className="h-4 w-4 mr-1" />} Partager ({sel.size})
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
